export default customElements.define('w-button-2', class Button extends wealthify.componentBases.Button {

    submitCallback = null;
    #styleSelector;

    constructor () {
        const styleSelector = 'c-button2';
        const config = {
            styleSelector,
            templateHTML: `
                <button class="${styleSelector}__container" type="button" data-root data-button>
                    <w-icon class="${styleSelector}__icon ${styleSelector}__icon--left" data-iconleft></w-icon>
                    <div class="${styleSelector}__label" data-content></div>
                    <w-icon class="${styleSelector}__icon ${styleSelector}__icon--right" data-iconright></w-icon>
                </button>`,
            cacheDom: [ 'data-content', 'data-iconleft', 'data-iconright', 'data-button' ]
        };

        super(config);

        this.#styleSelector = styleSelector;

        this.onConnectedCallback = () => {
            this.classList.add(this.#styleSelector);
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('fullwidth', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            new wealthify.Prop('is-inline-mobile', {
                type: wealthify.propTypes.Boolean(),
                default: false
            })
        ];
    }

    get propCallbacks() {
        return {
            fullwidth: () => {
                const classListAction = this.fullwidth ? 'add' : 'remove';
                
                this.classList[classListAction](`${this.#styleSelector}--fullwidth`);
                this.dom.root.classList[classListAction](`${this.#styleSelector}__container--fullwidth`);
            },
            isInlineMobile: () => {
                const classListAction = this.isInlineMobile ? 'add' : 'remove';

                this.classList[classListAction](`${this.styleSelector}--is-inline-mobile`);
            }
        };
    }

    focus(){
        this.dom.button.focus();
    }
});